import Vue from "vue";
import { QUESTION_INFO } from "@/components/StateAnswer.vue";

const state = {
  answers: {
    job: "online_selling",
    // gender: null,
    taxType: null,
    isIncomeOver: null,
    isRegisteredVat: null,
    isWantToRegisterVat: null,
    goodsType: null,
    isCheat: null,
    finalTaxType: null,
  },
  questionPaths: [],
};

// Getter functions
const getters = {
  getAnswers(state) {
    return state.answers;
  },
  questionPaths(state) {
    return state.questionPaths;
  },
};

// Actions
const actions = {
  changeAnswer(context, payload) {
    const { name, value } = payload;
    if (context.state.answers[name] !== value) {
      const oldQuestionPaths = context.state.questionPaths;
      const oldQuestionStates = oldQuestionPaths.map((path) =>
        QUESTION_INFO.find((state) => state.path === path)
      );
      const oldQuestionIndex = oldQuestionStates.findIndex(
        (state) => state.name === name
      );
      const newQuestionPaths = Vue.lodash.slice(
        oldQuestionPaths,
        0,
        oldQuestionIndex + 1
      );
      context.commit("setQuestionPaths", newQuestionPaths);

      const answers = {};
      newQuestionPaths.forEach((path) => {
        const state = QUESTION_INFO.find((state) => state.path === path);
        if (state) {
          answers[state.name] = context.state.answers[state.name];
        }
      });

      context.commit("setAnswers", { answers });
    }
    context.commit("setAnswer", payload);
  },
  setQuestionPaths(context, payload = {}) {
    context.commit("setQuestionPaths", payload.questionPaths);
  },
};
// Mutations
const mutations = {
  setAnswers(state, payload) {
    state.answers = payload.answers;
  },
  setAnswer(state, payload) {
    state.answers[payload.name] = payload.value;
  },
  setQuestionPaths(state, questionPaths) {
    if (!(questionPaths instanceof Array)) {
      throw "questionPaths not be array!";
    }
    state.questionPaths = questionPaths;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
